var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toast } from "react-toastify";
import { Router } from './router';
import { cities } from "@ts/dashboard/helpers";
import { DashboardCategory } from "@ts/dashboard/enums";
var fetchApi = function (route, method, query, body, stringifyBody, headers) {
    if (query === void 0) { query = {}; }
    if (body === void 0) { body = null; }
    if (stringifyBody === void 0) { stringifyBody = true; }
    if (headers === void 0) { headers = {}; }
    var url = generateRoute(route, query, false);
    var params = {
        method: method,
        headers: __assign(__assign({}, getDefaultApiHeaders()), headers),
        cache: "no-store"
    };
    if (body) {
        params['body'] = stringifyBody ? JSON.stringify(body) : body;
    }
    return fetch(url, params);
};
var generateCdnUrl = function (filename, filter) {
    return generateRoute('cdn_url', { filename: filename, filter: filter }, false);
};
var generateDownloadLink = function (filepath, query) {
    if (query === void 0) { query = {}; }
    filepath = btoa(filepath);
    query = __assign(__assign({}, query), { filepath: filepath });
    return generateRoute('download_pdf', query, false);
};
var getDefaultApiHeaders = function () {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };
};
var getFromLocalStorage = function (key) {
    var value = localStorage.getItem(key);
    if (!value) {
        return null;
    }
    var item = JSON.parse(value);
    var now = new Date();
    if (item.expiry && now.getTime() >= item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
};
var saveInLocalStorage = function (key, value, ttl) {
    var item = { value: value };
    if (ttl) {
        var now = new Date();
        item.expiry = now.getTime() + ttl;
    }
    localStorage.setItem(key, JSON.stringify(item));
};
var showError = function (message) {
    toast.error(translate(message), {
        autoClose: false,
        theme: 'colored'
    });
};
var showSuccess = function (message, redirectUri, autoClose) {
    if (autoClose === void 0) { autoClose = false; }
    toast.success(translate(message), {
        autoClose: redirectUri || autoClose ? 1500 : false,
        onClose: redirectUri ? function () { return window.location.href = redirectUri; } : function () {
        },
        theme: 'colored'
    });
};
var showWarning = function (message) {
    toast.warning(translate(message), {
        autoClose: false,
        theme: 'colored'
    });
};
export function mapRowsToRowsWithLinkWithHoverComparison(rowsObject, dashboardCategory) {
    var result = {};
    var _loop_1 = function (item) {
        var baseRows = mapRowsToRowsWithLinkWithHover(rowsObject[item], dashboardCategory);
        baseRows.map(function (baseRow) {
            var originalRow = rowsObject[item].find(function (row) { return row.label === baseRow.label; });
            if (originalRow) {
                if (!result[item]) {
                    result[item] = [];
                }
                result[item].push(__assign(__assign({}, baseRow), { tag_name: originalRow.tag_name }));
            }
        });
    };
    for (var item in rowsObject) {
        _loop_1(item);
    }
    return result;
}
export function mapRowsToRowsComparison(rowsObject) {
    var result = {};
    for (var item in rowsObject) {
        result[item] = mapRowsToRows(rowsObject[item]);
    }
    return result;
}
export function mapRowsRankingToRowsWithLink(rows, dashboardCategory) {
    var baseRows = mapRowsToRowsWithLink(rows, dashboardCategory);
    return baseRows.map(function (baseRow) {
        var originalRow = rows.find(function (row) { return row.label === baseRow.label; });
        if (originalRow) {
            return __assign(__assign({}, baseRow), { ranking: originalRow.ranking });
        }
        return baseRow;
    });
}
export function mapRowsToRows(rows) {
    return rows.map(function (row) { return ({
        label: row.label,
        bar_background: handleGraphColor(row),
        value: row.value,
        value_label: row.value_label,
    }); });
}
export function mapRowsToRowsWithLink(rows, dashboardCategory, type, season, top20) {
    var baseRows = mapRowsToRows(rows);
    return baseRows.map(function (row) {
        var routeParams = getRouteParams(dashboardCategory, row);
        if (type) {
            routeParams.type = type;
        }
        if (season) {
            routeParams.season = season;
        }
        if (top20) {
            routeParams.top_20_brands = top20;
        }
        return __assign(__assign({}, row), { url: generateRoute('data_dashboard_show', routeParams, false) });
    });
}
export function mapRowsToRowsWithLinkWithHover(rows, dashboardCategory, type) {
    var baseRows = mapRowsToRowsWithLink(rows, dashboardCategory, type);
    return baseRows.map(function (baseRow) {
        var originalRow = rows.find(function (row) { return row.label === baseRow.label; });
        if (originalRow) {
            return __assign(__assign({}, baseRow), { image_filename: originalRow.image_filename, look: originalRow.look, season_short: originalRow.season_short });
        }
        return baseRow;
    });
}
var getRouteParams = function (dashboardCategory, row) {
    if (dashboardCategory === DashboardCategory.Trends) {
        return {
            slug: 'trend-focus',
            trend: row.label,
        };
    }
    if (dashboardCategory === DashboardCategory.Brands) {
        return {
            slug: 'brand-focus',
            brand: row.label,
        };
    }
    return {
        slug: 'season-focus',
        brand: row.label,
    };
};
var handleGraphColor = function (row) {
    if (row.city_name) {
        return handleCityBasedColor(row.city_name);
    }
    if (row.bar_background) {
        return row.bar_background;
    }
    var queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('trend')
        || queryParams.has('brand')
        || queryParams.has('season')) {
        return 'var(--color-dashboard-pill-1)';
    }
    return 'var(--color-dashboard-graph-base)';
};
var handleCityBasedColor = function (cityTitle) {
    var city = cities.find(function (item) { return item.title === cityTitle; });
    return city ? city.color : 'var(--color-dashboard-graph-base)';
};
export var snakeCaseObjectToCamelCase = function (object) {
    Object.keys(object).forEach(function (key) {
        var value = object[key];
        delete object[key];
        var nextKey = snakeCaseToCamelCase(key);
        object[nextKey] = value;
        if (value !== null && typeof object[nextKey] === 'object') {
            snakeCaseObjectToCamelCase(object[nextKey]);
        }
    });
    return object;
};
var snakeCaseToCamelCase = function (value) {
    return value
        .split('_')
        .reduce(function (result, current, index) {
        current = index !== 0 ? current[0].toUpperCase() + current.slice(1) : current;
        return result + current;
    }, '');
};
var getLang = function () {
    var html = document.documentElement;
    var dataLang = html.getAttribute('data-lang');
    if (dataLang) {
        return dataLang;
    }
    return html.lang;
};
var generateRoute = function (route, query, intl) {
    if (query === void 0) { query = {}; }
    if (intl === void 0) { intl = true; }
    if (intl) {
        route = route + "." + getLang();
    }
    return Router.generate(route, query);
};
var getFileVariant = function (filename, filter, cdn) {
    return cdn + "/" + filter + "/" + filename;
};
var translate = function (id, params, domain) {
    if (params === void 0) { params = {}; }
    if (domain === void 0) { domain = 'messages'; }
    return Translator.trans(id, params, domain);
};
var translateChoice = function (id, number, params, domain) {
    if (params === void 0) { params = {}; }
    if (domain === void 0) { domain = 'messages'; }
    return Translator.transChoice(id, number, params, domain);
};
export { fetchApi, generateCdnUrl, generateDownloadLink, getFromLocalStorage, saveInLocalStorage, showError, showSuccess, showWarning, getLang, generateRoute, getFileVariant, translate, translateChoice, };
